import React from 'react';
import { useSelector } from "react-redux";
import styles from './MyPropertyPromoChartOverlay.less';
import { TAB } from '../Navigation/Menu/menuConfig';
import tracking from '../../tracking/tracking';
import { FUTURE_PRICE_TREND_LINK_MY_PROPERTY } from '../../tracking/trackingNaming';
import { getHierarchyLevel } from "../../selectors/selectors";

const MyPropertyPromoChartOverlay = ({ trackingAction }) => {
  const hierarchyLevel = useSelector(getHierarchyLevel);
  const redirectToMyProperty = (event, hierarchyLevel) => {
    tracking.report(FUTURE_PRICE_TREND_LINK_MY_PROPERTY, trackingAction);
    event.preventDefault();
    if (hierarchyLevel === 'country') {
      window.location.pathname = '/eigentuemerbereich';
    } else {
      window.location.hash = TAB.myProperty.name;
    }
  };

  return (
    <button
      id="my-property-promo-chart-overlay-button"
      type="button"
      onClick={(event) => redirectToMyProperty(event, hierarchyLevel)}
      className={styles.chartOverlayBox}
    >
      <div data-qa="MyPropertyPromoChartOverlay-icon2" className={styles.chartOverlayIcon}>
        <span className="is24-icon-statistics" />
      </div>
      <div className={styles.chartOverlayText}>Für kostenfreie Preisprognose anmelden</div>
    </button>
  );
};

export default MyPropertyPromoChartOverlay;
